export const DEFAULT_COLUMN_WIDTH = 160
export const PIN_COLUMN_KEY = "__report_pin_action"
export const SERIAL_COLUMN_KEY = "__report_serial_number"
export const MAX_PINNED_ROWS = 5
export const MAX_FROZEN_COLUMNS = 4
export const DEFAULT_VIRTUAL_SCROLL_Y = 560
export const DEFAULT_VIRTUAL_ROW_THRESHOLD = 100
export const REPORT_TABLE_DROPDOWN_Z_INDEX = 100100
